<template>
    <div class="honor">
        <div class="title wow fadeInUp">
            企业荣誉
        </div>
       <p class="t1 wow fadeInUp">每一次的肯定都是对我们不断前进的莫大动力</p>
      <div class="allItems wow fadeInUp">
           <div  class="item"  v-for="(item,index) in list" :key="index">
              <div class="one">
                  <img :src="`http://www.znr.com.cn/${item.picurl}`" alt="">
              </div>
               <div class="two">
                   <span>{{item.title}}</span>
                   <span><i class="iconfont icon-fangda"></i></span>
               </div>
           </div>
      </div>
        <div class="page wow fadeInUp">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :page-count="totalPage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {PageModel} from '../util/lang'
    export default {
        name: "honor",
        data(){
            return{
                totalPage:0,
                id:'',
               list:[]
            }
        },
mounted(){
      this.$nextTick(()=>{
          if(this.$i18n.locale==='en'){
              this.getProList('105')
          }else{
              this.getProList('5')
          }

      })
},
        methods:{
            handleCurrentChange(val) {
                if(val<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${PageModel('PageModel',val++,8,this.id)}`
                        this.$axios.get(url).then(res => {
                            this.list=res.data.data
                            // console.log(res.data)
                        })
                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already Loaded',
                        offset: 100
                    });
                }
            },
            getProList(id){
                this.id=id
                // console.log(this.id)
                const url = `${PageModel('PageModel',1,8,id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                    this.totalPage=res.data.totalPage
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.honor{
    width:1440px;
    margin: 60px auto;
    animation-duration: 3s;
    .title{
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: "SOURCEHANSANSCN-BOLD";
        font-size: 30px;
        &::after{
            content:'';
            width:24px;
            height:2px;
            background:rgba(109,45,121,1);
            display: inline-block;
            margin: 20px auto;
        }
    }
    .t1{
        text-align: center;
        font-family: "SOURCEHANSANSCN-LIGHT";
    }
    .allItems{
             width:100%;
             display: flex;
             flex-direction: row;
             flex-wrap: wrap;
             margin: 60px auto;
             .item{
                 width:23%;
                 margin-left: 1%;
                 border: 1px solid #999999;
                 cursor: pointer;
                 margin-top: 20px;
                 transition: all 600ms;
                 .one{
                     width:100%;
                     text-align: center;
                     padding: 30px 0;
                     border-bottom: 1px solid #999999;
                     overflow: hidden;
                     img{
                         transition: all 600ms;
                     }
                 }
                 .two{
                     width:90%;
                     margin: 15px auto;
                     display: flex;
                     flex-direction: row;
                     justify-content: space-between;
                     align-items: center;
                     padding: 5px 0;
                     span{
                         transition: all 600ms;
                     }
                     span:nth-child(1){
                         font-size: 18px;
                         transition: all 600ms;
                         font-family: "SourceHanSansSC-Medium";
                     }
                     span:nth-child(2){
                         i{
                             font-size: 20px;
                             transition: all 600ms;
                         }
                     }
                 }
                 &:hover{
                     box-shadow: 0 0 0 8px rgba(109,45,121,1);
                     .one{
                         img{
                             transform: scale(1.05);
                         }
                     }
                     .two{
                         span{
                             color:rgba(109,45,121,1);
                         }
                     }
                 }
             }
         }
    .page{
        width:98%;
        margin: 40px auto;
        text-align: center;
        background: #F6F6F6;
        padding: 20px 0;
    }
    @media screen and (max-width: 1440px){
    }
}
</style>
